module.exports = __webpack_public_path__ + "static/media/aster_footer.5f1de0bb.png";